import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=e4c6a6f0&scoped=true&"
import script from "./page6.vue?vue&type=script&lang=js&"
export * from "./page6.vue?vue&type=script&lang=js&"
import style0 from "./page6.vue?vue&type=style&index=0&id=e4c6a6f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c6a6f0",
  null
  
)

export default component.exports